import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Grid from "@material-ui/core/Grid"
import { connect } from "react-redux";
const useStyles = makeStyles({
  root: {
    width: 300,
  },
});

function valuetext(value) {
  return `${value}°C`;
}
function FlairSentimentScoreSlider(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(props.scoresSubjectivityRange);

  const handleChange = (event, newValue) => {
    //props.Set_Selected_scoresSubjectivityRange(newValue)
    setValue(newValue);
  };
  const commitChange = (event, newValue) => {
    props.Set_Selected_scoresSubjectivityRange(newValue)
    //setValue(newValue);
  };
  return (
    <Grid container style={{width:70,marginTop:4,marginLeft:5}} direction="column" justify="flex-start" alignItems="flex-start">
      <Slider
        value={value}
        onChange={handleChange}
        onChangeCommitted={commitChange}
        valueLabelDisplay="auto"
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
        step={0.01}
        min={props.scoresSubjectivityRange[0]}
        max={props.scoresSubjectivityRange[1]}
      />
    </Grid>
  );
}
const maptstateToprop = (state) => {
  return {
    scoresSubjectivityRange: state.scoresSubjectivityRange,
  }
}
const mapdispatchToprop = (dispatch) => {
  return {
    Set_Selected_scoresSubjectivityRange: (val) => dispatch({ type: "Selected_scoresSubjectivityRange", value: val })
  }
}
export default connect(maptstateToprop, mapdispatchToprop)(FlairSentimentScoreSlider);